// Install guides for self-install trackers, per model. PLACEHOLDER TEXT: the real steps and
// photos per model come from Fleet Functions (CLAUDE.md task 6, "To do before launch").
// Add a model by adding an entry to GUIDES; models without one get the general guide.

export interface GuideStep {
  title: string;
  text: string;
  // Path of a photo under web/public/guide/, e.g. "/guide/fmc920-wiring.jpg".
  photo?: string;
}

export interface Guide {
  title: string;
  steps: GuideStep[];
  leds?: Array<{ light: string; meaning: string }>;
}

const GENERAL: Guide = {
  title: 'Fitting your tracker',
  steps: [
    { title: 'Find a spot', text: 'Choose a place under the dashboard or behind a panel where the tracker has a view of the sky through plastic or glass, not under metal.' },
    { title: 'Connect the power', text: 'Connect the red wire to a permanent 12 V or 24 V supply and the black wire to ground. Placeholder: the real wiring for your model will be shown here.' },
    { title: 'Ignition (optional)', text: 'Connect the ignition wire to a supply that is only live with the ignition on, so journeys start and end at the right time.' },
    { title: 'Fix it in place', text: 'Fix the tracker firmly with cable ties or the double-sided pad so it can\'t rattle or move.' },
    { title: 'Switch on and check', text: 'Switch the ignition on. The lights on the tracker start flashing; after a few minutes outdoors it finds its position.' },
  ],
  leds: [
    { light: 'Navigation light flashing', meaning: 'Looking for a GPS position (placeholder)' },
    { light: 'Navigation light steady', meaning: 'Position found (placeholder)' },
    { light: 'Status light flashing', meaning: 'Connected to the mobile network (placeholder)' },
  ],
};

const GUIDES: Record<string, Guide> = {};

export const guideFor = (model: string | null | undefined): Guide => (model && GUIDES[model]) || GENERAL;
